import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts"
import AnalyticsRepository from "../../repository/AnalyticsRepository"
import { useEffect, useState } from "react"
import { generateDistinctHexColors } from "../../shared/utils/ColorUtils"

export default function DashboardPageAnalytics({ 
    analytics,
    viewingMap,
 }) {

    const [mapDailyAnalytics, setMapDailyAnalytics] = useState(null)
    const [uniqueUsersDailyAnalytics, setUniqueUsersDailyAnalytics] = useState(null)
    const [detailsViewDailyAnalytics, setDetailsViewDailyAnalytics] = useState(null)
    const [detailsViewCategories, setDetailsViewCategories] = useState([])
    const [detailsViewColors, setDetailsViewColors] = useState([])
    const [loadingText, setLoadingText] = useState(null)

    useEffect(() => {
        setDetailsViewColors(generateDistinctHexColors(detailsViewCategories.length))
    }, [detailsViewCategories])

    useEffect(() => {
        console.log(`viewingMap is ${JSON.stringify(viewingMap)}`)

        async function getMapDailyAnalytics() {
            setLoadingText("Loading ...")
            const analyticsRepository = new AnalyticsRepository()
            const mapDailyAnalytics = await analyticsRepository.getMapDailyAnalytics(viewingMap.slug)
            console.log(`mapDailyAnalytics is ${JSON.stringify(mapDailyAnalytics)}`)
            setMapDailyAnalytics(mapDailyAnalytics.mapViews.map(mapView => ({
                date: mapView.date,
                mapViewCounts: mapView.categoryToCounts.mapViewCounts,
                listViewCounts: mapView.categoryToCounts.listViewCounts
            })))

            setUniqueUsersDailyAnalytics(mapDailyAnalytics.uniqueViewers.map(uniqueUser => ({
                date: uniqueUser.date,
                uniqueViewerCounts: uniqueUser.categoryToCounts.uniqueViewers
            })))


            const detailsViewLabels = []
            setDetailsViewDailyAnalytics(mapDailyAnalytics.detailViews.map(detailsView => {
                const detailsViewCounts = detailsView.categoryToCounts
                const detailsNameViewCounts = {}
                Object.keys(detailsViewCounts).forEach(detailId => {
                    const detailName = mapDailyAnalytics.placeIdToName[detailId]
                    detailsNameViewCounts[detailName] = detailsViewCounts[detailId]
                    if (!detailsViewLabels.includes(detailName)) {
                        detailsViewLabels.push(detailName)
                    }
                })
                return {
                    ...detailsNameViewCounts,
                    date: detailsView.date
                }
            }))
            console.log(`detailsViewLabels is ${JSON.stringify(detailsViewLabels)}`)
            setDetailsViewCategories(detailsViewLabels)

            setLoadingText(null)
        }

        getMapDailyAnalytics()
    }, [viewingMap])

    return (
        <div className="h-full w-full flex flex-col flex-1 py-4 bg-base-200 gap-8">
            {
                loadingText && <div className="flex justify-center items-center h-full flex flex-row gap-2">
                    <span className="loading loading-spinner text-primary"></span>
                    {loadingText}
                </div>
            }
            {mapDailyAnalytics && <div>
                <div className="px-8 text-center w-full text-lg text-base-content pb-2 font-titan">
                    Total map and list views for the last 30 days
                </div>
                {
                    <div className="px-16">
                        <BarChart
                    style={{ width: '100%', minWidth: '100%', maxHeight: '70vh', aspectRatio: 1.618 }}
                    responsive
                    data={mapDailyAnalytics}
                    margin={{
                      top: 20,
                      right: 0,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis width="auto" />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="mapViewCounts" name="Map View" stackId="a" fill="#8884d8" />
                    <Bar dataKey="listViewCounts" name="List View" stackId="a" fill="#82ca9d" />
                  </BarChart>
                    </div>
                }
            </div>
            }

            {uniqueUsersDailyAnalytics && <div>
                <div className="px-8 text-center w-full text-lg text-base-content pb-2 font-titan">
                    Total unique viewers for the last 30 days
                </div>
                {
                    <div className="px-16">
                        <BarChart
                    style={{ width: '100%', minWidth: '100%', maxHeight: '70vh', aspectRatio: 1.618 }}
                    responsive
                    data={uniqueUsersDailyAnalytics}
                    margin={{
                      top: 20,
                      right: 0,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis width="auto" />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="uniqueViewerCounts" name="Unique Viewer" stackId="a" fill="#8884d8" />
                  </BarChart>
                    </div>
                }
            </div>
            }

            {detailsViewDailyAnalytics && <div>
                <div className="px-8 text-center w-full text-lg text-base-content pb-2 font-titan">
                    Total details views for the last 30 days
                </div>
                {
                    <div className="px-16">
                        <BarChart
                    style={{ width: '100%', minWidth: '100%', maxHeight: '70vh', minHeight: '70vh' }}
                    responsive
                    data={detailsViewDailyAnalytics}
                    margin={{
                      top: 20,
                      right: 0,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis width="auto" />
                    <Tooltip />
                    <Legend />
                    {detailsViewCategories.map((category, index) => (
                        <Bar dataKey={category} name={category} stackId="a" fill={detailsViewColors[index]} />
                    ))}
                  </BarChart>
                    </div>
                }
            </div>
            }
        </div>
    )
 }